import { gsap } from 'gsap'

export function homeHeroVideo(video: HTMLVideoElement) : void {
  let mm = gsap.matchMedia()
  const desktopSrc: string | undefined = video.dataset.desktopSrc;
  const mobileSrc: string | undefined = video.dataset.mobileSrc;

  mm.add('(max-width: 768px)', () => {
    if (mobileSrc) {
      video.src = mobileSrc
      video.play()
    }
  })

  mm.add('(min-width: 769px)', () => {
    if (desktopSrc) {
      video.src = desktopSrc
      video.play()
    }
  })
}
